import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Colors } from 'advenio-components'
import DocumentCard from '../DocumentCard'

var GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 8px;
`

var NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  color: #637381;
  font-size: 14px;
  grid-column: 1 / -1;
`

var SkeletonCard = styled.div`
  background: #FFFFFF;
  border: 1px solid ${Colors.gray200};
  border-radius: 8px;
  padding: 20px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: pulse 1.5s ease-in-out infinite;
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
`

var SkeletonIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: ${Colors.gray200};
`

var SkeletonTitle = styled.div`
  width: 70%;
  height: 16px;
  border-radius: 4px;
  background: ${Colors.gray200};
`

var SkeletonMeta = styled.div`
  width: 50%;
  height: 12px;
  border-radius: 4px;
  background: ${Colors.gray200};
`

var SkeletonButton = styled.div`
  width: 80px;
  height: 32px;
  border-radius: 4px;
  background: ${Colors.gray200};
  margin-top: auto;
`

class DocumentGrid extends Component {
  renderSkeletons = () => {
    var skeletons = []
    for (var i = 0; i < 6; i++) {
      skeletons.push(
        <SkeletonCard key={'skeleton-' + i}>
          <SkeletonIcon />
          <SkeletonTitle />
          <SkeletonMeta />
          <SkeletonButton />
        </SkeletonCard>
      )
    }
    return skeletons
  }

  render () {
    var props = this.props

    if (props.fetching) {
      return (
        <GridContainer>
          {this.renderSkeletons()}
        </GridContainer>
      )
    }

    if (!props.documents || props.documents.length === 0) {
      return (
        <GridContainer>
          <NoResults>No hay documentos disponibles</NoResults>
        </GridContainer>
      )
    }

    return (
      <GridContainer>
        {props.documents.map(function (doc) {
          return (
            <DocumentCard
              key={doc.id}
              document={doc}
              onClick={props.onDocumentClick}
              onDistribute={props.onDistribute}
            />
          )
        })}
      </GridContainer>
    )
  }
}

DocumentGrid.propTypes = {
  documents: PropTypes.array,
  fetching: PropTypes.bool,
  onDocumentClick: PropTypes.func.isRequired,
  onDistribute: PropTypes.func.isRequired
}

DocumentGrid.defaultProps = {
  documents: [],
  fetching: false
}

export default DocumentGrid



// WEBPACK FOOTER //
// ./src/Components/Documents/DocumentGrid/index.jsx